<template>
  <div class="card-sections-block-footer">
    <div v-if="card.info
          && (card.info.card_type === 'card' || card.info.card_type === 'top_level')
        "
    >
      <el-table
        class="card-summary-table card-section-elements-table"
        header-row-class-name="card-section-elements-table-header"
        row-class-name="evraz-summary-row"
        style="width: 100%; margin-bottom: 25px"
        :data="summary"
      >
        <el-table-column label="ИТОГО"></el-table-column>
        <el-table-column label="Вес" :width="width.weight">
          <template v-slot="scope">
            {{ scope.row.weight|numberFormat }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="this.card.status===this.$constants.card.statuses.STATUS_COMPLETED || (currentStage && currentStage.type === $constants.stage.types.TYPE_ASSESSMENT)"
          label="Оценка"
          :width="width.fact"
        >
          <template v-slot="scope">
            {{ card.bonus|numberFormat }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="adminBonusVisible"
          label="Оценка админа"
          :width="200"
        >
          <template v-slot="scope">
            <span v-if="card.info.admin_bonus !== null">{{ card.info.admin_bonus|numberFormat }}</span>
            <span v-else>{{ card.bonus|numberFormat }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      v-if="$canAndRulesPass(card, 'card.info_calibration_comment_see')"
    >
      <div style="font-size: 1.1rem; font-weight: bold; margin-bottom: 5px">Комментарий калибровки</div>
      <el-input
        v-model="card.info.calibration_comment"
        :disabled="!$canAndRulesPass(card, 'card.info_calibration_comment_update')"
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 6}"
        @change="infoFieldChanged('calibration_comment')"
      ></el-input>

    </div>

    <div v-if="this.card.status===this.$constants.card.statuses.STATUS_COMPLETED || (currentStage && currentStage.type === $constants.stage.types.TYPE_ASSESSMENT)">
      <div v-if="card.info && card.info.card_type === 'abcd'">
        <div v-if="$canAndRulesPass(card, 'card.info_pre_point_see')">
          <div style="display: inline-block; width: 240px;">Предварительная оценка:</div>
          <el-select
            v-model="card.info.pre_point"
            :disabled="!$canAndRulesPass(card, 'card.info_pre_point_update')"
            clearable
            style="width: 200px"
            size="small"
            placeholder="Выберите оценку"
            @change="savePoint('pre_point')"
          >
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
            <el-option label="D" value="D"></el-option>
          </el-select>
        </div>
        <div v-if="$canAndRulesPass(card, 'card.info_final_point_see')">
          <div style="display: inline-block; width: 240px; margin: 20px 0;">ИТОГОВАЯ ОЦЕНКА:</div>
          <el-select
            v-model="card.info.final_point"
            :disabled="!$canAndRulesPass(card, 'card.info_final_point_update')"
            style="width: 200px"
            clearable
            size="small"
            placeholder="Выберите оценку"
            @change="savePoint('final_point')"
          >
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
            <el-option label="D" value="D"></el-option>
          </el-select>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import SearchInput from "@/components/filters/SearchInput";
import CardsYearSelect from "@/components/filters/cards/CardsYearSelect";
import CardsStageSelect from "@/components/filters/cards/CardsStageSelect";
import CardsStageNegotiationSelect from "@/components/filters/cards/CardsStageNegotiationSelect.vue";
import CardsPeriodSelect from "@/components/filters/cards/CardsPeriodSelect.vue";
import UserSelect from "@/components/filters/users/UserSelect.vue";
import CardsStatusSelect from "@/components/filters/cards/CardsStatusSelect.vue";
import {mapGetters} from "vuex";
import {downloader} from "@/mixins/downloader";
import CloneElementsFromCardModal from "@/components/cards/CloneElementsFromCardModal.vue";
import HistoryModal from "@/components/HistoryModal.vue";
import StartDynamicStageButton from "@/components/cards/StartDynamicStageButton.vue";
import {cardInfoField} from "@/mixins/cardInfoField";

export default {
  name: "card-sections-block-footer",
  mixins: [downloader, cardInfoField],
  components: {StartDynamicStageButton, HistoryModal, CloneElementsFromCardModal},
  props: {},

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card'
    }),
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
    }),
    ...mapGetters('card/sections', {
      sections: 'sections',
      sectionsElements: 'sectionsElements',
    }),
    summary() {
      let totalWeight = 0;

      this.sections.forEach(section => {
        if (this.$companyConfiguration.cardSections.isSectionMultiplyElementsBonus(section.type)) {
          // Для кэфов не нужно считать вес
          return;
        }
        if (!this.sectionsElements[section.id]) {
          return;
        }
        this.sectionsElements[section.id].forEach(e => {
          totalWeight += +e.weight;
        })
      })

      return [{
        weight: +totalWeight.toFixed(2),
      }]
    },

    width() {
      let weightWidth = 0;
      let factWidth = 0;
      if (this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_PLAN) {
        weightWidth = 1210;
      }
      if (this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_ASSESSMENT) {
        weightWidth = this.user.roles.includes('admin') ? 820 : 880;
        factWidth = this.user.roles.includes('admin') ? 500 : 420;
      }
      if (this.card.status === this.$constants.card.statuses.STATUS_COMPLETED) {
        weightWidth = this.user.roles.includes('admin') ? 820 : 880;
        factWidth = this.user.roles.includes('admin') ? 500 : 420;
      }
      return {
        'weight': weightWidth,
        'fact': factWidth,
      }
    },

    adminBonusVisible(){

      if( !this.user.roles.includes("admin") ){
        return false;
      }

      if( !this.$canAndRulesPass(this.card, "card.is_full_for_current_user") ){
        return false;
      }

      if( this.card.status === this.$constants.card.statuses.STATUS_COMPLETED ){
        return true;
      }
      if( this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_ASSESSMENT ){
        return true;
      }

      return false;
    }
  },
  watch: {},
  data() {
    return {
      loadingPointChange: false,
    }
  },
  methods: {
    savePoint(pointType) {
      this.loadingPointChange = true;
      this.infoFieldChanged(pointType)
        .then(() => {
          this.$store.dispatch('card/loadCardData');
          this.$store.dispatch('card/sections/loadSections');
          this.$store.dispatch('card/stages/loadStages');
        })
        .finally(() => {
          this.loadingPointChange = false;
        })
    },
  }
}
</script>


<style lang="scss">
.evraz-summary-row {
  font-weight: bold;
}
</style>